import React from 'react';
import { Dialog, DialogActions, DialogContent, Typography } from '@material-ui/core';
import { Button, BUTTON } from 'components/common/Button/Button';
import ReportDialogTitle from 'pages/report/components/ReportDialogTitle';
import styles from './styles.scss';

export default function DialogDeactivateUser({ user, isOpen, toggleDialog, handleEndDelegations }) {
    function handleCloseDialog() {
        toggleDialog(false);
    }
    return (
        <Dialog
            open={isOpen}
            onClose={handleCloseDialog}
            fullWidth
            aria-labelledby="form-dialog-title"
            className={styles.dialogContainer}
        >
            <ReportDialogTitle onClose={handleCloseDialog} />
            <DialogContent>
                <Typography gutterBottom>
                    {`Do you want to set ${user.displayName}’s open Delegation Log end dates to today?`}
                </Typography>
            </DialogContent>
            <DialogActions className={styles.dialogAction}>
                <Button
                    className={styles.btnOutline}
                    onClick={() => handleEndDelegations(true) }
                    bgcolor={BUTTON.BGCOLOR.CLEAR}
                    color={BUTTON.COLOR.GREY}
                    text={'Yes'}
                />
                <Button
                    className={styles.btnFilled}
                    onClick={() => handleEndDelegations(false) }
                    bgcolor={BUTTON.BGCOLOR.ORANGE}
                    color={BUTTON.COLOR.WHITE}
                    text={'No'}
                />
            </DialogActions>
            <DialogActions className={styles.cancelContainer}>
                <Button
                    onClick={handleCloseDialog}
                    bgcolor={BUTTON.BGCOLOR.CLEAR}
                    color={BUTTON.COLOR.RED}
                    text={'Cancel'}
                />
            </DialogActions>
        </Dialog>
    );
}
